<template>
      <router-view/>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      Portal: state => state.Portal
    })
  }
};
</script>
